import React, { Suspense, lazy } from 'react';
import Loader from '~components/main-loader';

const DigestsPage = lazy(() => import('./index'));

function DigestsPageOldLazy(props) {
    return (
        <Suspense fallback={<Loader />}>
            <DigestsPage {...props} />
        </Suspense>
    );
}

export default DigestsPageOldLazy;
export { DigestsPageOldLazy };



// WEBPACK FOOTER //
// ./src/routes/main/laws-digests-item-old-page/lazy.js